
















































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';

type NumberFieldVariant = 'normal' | 'custom';

let interval: NodeJS.Timeout;

@Component({
  components: {
    Typography
  }
})
export default class NumberField extends Vue {
  @Prop({ required: false }) private label?: string;
  @Prop({ required: false }) private unit?: string;
  @Prop({ required: false, default: 0 }) private value!: number;
  @Prop({ required: false, default: 0 }) private step!: number;
  @Prop({ required: false }) private min?: number;
  @Prop({ required: false }) private max?: number;
  @Prop({ required: false, default: false }) private controls!: boolean;
  @Prop({ default: false }) customControls?: boolean;
  @Prop({ default: 'normal' }) variant?: NumberFieldVariant;
  @Prop({ default: false }) disabled?: boolean;

  internalValue = this.value;
  key = 0;

  private onChange(event: any) {
    let value = parseInt(event.target && event.target.value, 10);

    if (typeof this.max === 'number') {
      if (value > this.max) {
        // Rerender component to update input value to the max value
        this.key += 1;
      }

      value = Math.min(value, this.max);
    }

    if (typeof this.min === 'number') {
      if (value < this.min) {
        // Rerender component to update input value to the min value
        this.key += 1;
      }

      value = Math.max(value, this.min);
    }

    this.internalValue = value;
    this.$emit('change', value);
  }

  handleControlClick(type: string) {
    this.$emit('control-click', type);
  }

  mousedown(type: string) {
    if (this.disabled) return;

    interval = setInterval(() => {
      this.handleControlClick(type);
    }, 50);
  }

  mouseup() {
    clearInterval(interval);
  }

  get enableDirectionIcon() {
    const allowedVariants = ['custom'];

    return this.variant && allowedVariants.includes(this.variant);
  }
}
